import { Component, OnInit } from '@angular/core';
import { EqualValidator } from './../../directives/equal-validator.directive';
import { User } from './user.interface';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { logbaseService } from '../../services/logbase.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  unamePattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})");
  oldPassword: string;
  newPassword: string;
  loginId: string;
  payload: {};
  errorMessage: any;
  response: any[];
  constructor(
    private userService: logbaseService,
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router, private translate: TranslateService

  ) { }
  loggedInUser: any;
  userDetail: string;
  public user: User;

  ngOnInit() {
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.loggedInUser = userDetJson.loginId;
    this.user = {
      username: this.loggedInUser,
      oldpassword: '',
      password: '',
      confirmPassword: ''
    }

  }
  postFormError() {
    this.toastr.warning('Problem while Submission, Kindly check your network status');
  }

  save(model: User, isValid: boolean) {
    let resetformData = {
      "loginId": model.username,
      "newPassword": model.password,
      "oldPassword": model.oldpassword
    }
    this.userService.resetuserPassword(resetformData).subscribe(
      data => {
        // set success message and pass true paramater to persist the message after redirecting to the login page
        if (data.status.statusMessage == "SUCCESS") {
          this.toastr.success(this.translate.instant('PASSWORD_RESET_SUCCESS'));
          this.router.navigate(['/login']);
        }
        else {
          this.toastr.warning(data.status.displayMessage);
        }
      },
      error => {
        this.postFormError();
      });;
  }
}
